import styled from "styled-components";

export const Hero = styled.div``;
